import React, { useState } from 'react';
import '../styles/pages/BoxBagPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const BoxBagPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const boxBagTypes = [
    {
      id: 1,
      title: "Medicine Box",
      icon: "💊",
      description: "High-quality medicine boxes designed for safety and branding. Durable and compliant with medical packaging standards.",
      features: [
        "Tamper-evident seals",
        "Custom branding",
        "FDA compliant materials",
        "Protective cushioning",
        "Easy to open design",
        "Eco-friendly options"
      ],
      specifications: {
        material: "Cardboard, plastic inserts",
        thickness: "300-600 GSM",
        width: "Custom sizes",
        durability: "2-3 years",
        applications: "Pharmaceutical packaging"
      },
      image: "https://images.unsplash.com/photo-1588776814546-0a7a1a1a1a1a?w=500&h=350&fit=crop",
      color: "#ef4444",
      bestFor: ["Pharmaceuticals", "Healthcare products", "Medical supplies"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1588776814546-0a7a1a1a1a1a?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1588776814546-0a7a1a1a1a1a?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1588776814546-0a7a1a1a1a1a?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1588776814546-0a7a1a1a1a1a?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Sweet Box",
      icon: "🍬",
      description: "Attractive sweet boxes that preserve freshness and enhance gift appeal. Customizable with vibrant prints and finishes.",
      features: [
        "Food-safe materials",
        "Custom shapes and sizes",
        "Glossy and matte finishes",
        "Easy to assemble",
        "Durable construction",
        "Vibrant color printing"
      ],
      specifications: {
        material: "Cardboard, food-grade coatings",
        thickness: "250-500 GSM",
        width: "Custom sizes",
        durability: "1-2 years",
        applications: "Confectionery packaging"
      },
      image: "https://images.unsplash.com/photo-1505253210343-1a1a1a1a1a1a?w=500&h=350&fit=crop",
      color: "#f59e0b",
      bestFor: ["Confectionery", "Gift packaging", "Retail display"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1505253210343-1a1a1a1a1a1a?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1505253210343-1a1a1a1a1a1a?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1505253210343-1a1a1a1a1a1a?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1505253210343-1a1a1a1a1a1a?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Carry Bag",
      icon: "🛍️",
      description: "Durable and stylish carry bags for retail and promotional use. Custom printed with your brand logo and designs.",
      features: [
        "Reusable materials",
        "Custom sizes and shapes",
        "Strong handles",
        "Vibrant printing",
        "Eco-friendly options",
        "Water-resistant coatings"
      ],
      specifications: {
        material: "Non-woven fabric, plastic",
        thickness: "Varies by material",
        width: "Custom sizes",
        durability: "Multiple uses",
        applications: "Retail, events, promotions"
      },
      image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&h=350&fit=crop",
      color: "#3b82f6",
      bestFor: ["Retail stores", "Trade shows", "Promotional events"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="box-bag-printing-page">
      <HeroSection
        heroTitle="Box & Bag Printing Services"
        heroSubtitle="Delivering premium packaging solutions with custom box and bag printing services tailored to your brand's needs."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={boxBagTypes}
        title="Our Premium Box & Bag Printing Solutions"
        subtitle="Delivering premium packaging solutions with custom box and bag printing services tailored to your brand's needs."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={boxBagTypes.map(boxBagType => ({
          id: boxBagType.id,
          title: boxBagType.title,
          icon: boxBagType.icon,
          gallery: boxBagType.portfolio?.gallery || []
        }))}
        title="Our Box & Bag Printing Portfolio"
        subtitle="Explore our premium box and bag printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default BoxBagPrinting;
